module.exports = __webpack_public_path__ + "img/1F1F9-1F1FF.d9e76d17.svg";